import { NullableClassName } from '@squareup/dex-types-shared-ui';
import { Grid, GridItemRenderProps } from '@squareup/dex-ui-shared-grid';
import { TrackedBox } from '@squareup/dex-ui-user-interaction-publisher';
import clsx from 'clsx';
import React, { FC, PropsWithChildren, ReactNode } from 'react';

import pageStyles from './page-layout.module.css';

export interface DocsPageContentLayoutProps {
  floatingToc?: ReactNode;
}

const DocsPageContentLayout: FC<
  PropsWithChildren<DocsPageContentLayoutProps & NullableClassName>
> = ({ children, floatingToc, className }) => {
  const render = ({ styles: gridStyles }: GridItemRenderProps) => {
    return (
      <>
        <TrackedBox
          className={clsx(
            pageStyles['content-main-grid-item'],
            floatingToc
              ? gridStyles['grid-item-medium']
              : gridStyles['grid-item-full'],
            floatingToc && pageStyles['limit-width']
          )}
          trackingId="main"
        >
          {children}
        </TrackedBox>
        {floatingToc && (
          <TrackedBox
            margin={{ top: '8x' }}
            className={clsx(
              pageStyles['floating-toc'],
              gridStyles['grid-item-small']
            )}
            trackingId="floating-toc"
          >
            {floatingToc}
          </TrackedBox>
        )}
      </>
    );
  };

  return (
    <Grid className={clsx(className)} variant="docs-content" render={render} />
  );
};

export { DocsPageContentLayout };
